{
  "familyId": "MET-OPP-RECHT",
  "questions": [
    {
      "id": "MET-OPP-RECHT-001",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een vloer is een rechthoek van 8 m lang en 5 m breed. Wat is de oppervlakte van de vloer?",
      "options": ["40 m²", "26 m²", "13 m²", "80 m²"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "geo", "data": { "width": 8, "height": 5, "showGrid": true, "unit": "m" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Oppervlakte rechthoek", "content": "Oppervlakte = lengte × breedte. Dus: 8 × 5 = 40 m². Het antwoord is in m² (vierkante meter).", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle",
      "variantIndex": 1,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Oppervlakte met omtrek verward", "optionIndex": 1 },
          { "id": "met.opp-optellen-ipv-vermenigvuldigen", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 2 },
          { "id": "met.opp-rekenfout", "label": "Rekenfout in oppervlakte-vermenigvuldiging", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Je rekent de oppervlakte uit met lengte × breedte = 8 × 5 = 40 m². Vergeet niet het ²-symbool: m × m = m².",
        "solutionSteps": ["Formule: oppervlakte = lengte × breedte", "Invullen: 8 × 5", "Uitkomst: 40 m²"],
        "distractorExplanations": {
          "0": "Goed! Oppervlakte = 8 × 5 = 40 m².",
          "1": "Je rekende waarschijnlijk de omtrek uit (8 + 5 + 8 + 5 = 26 m). Maar omtrek = de hele rand erom heen; oppervlakte = de ruimte ín de rechthoek. Voor oppervlakte vermenigvuldig je: 8 × 5 = 40 m².",
          "2": "Je telde lengte + breedte op (8 + 5 = 13). Dat is geen oppervlakte. Voor oppervlakte vermenigvuldig je de zijden: 8 × 5 = 40 m².",
          "3": "Je hebt waarschijnlijk nog eens × 2 gedaan (8 × 5 × 2 = 80). Dat is te veel. Oppervlakte = lengte × breedte, dus 8 × 5 = 40 m². Stop daar."
        }
      }
    },
    {
      "id": "MET-OPP-RECHT-002",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een tuinarchitect ontwerpt een tuin van 12 meter lang en 7 meter breed. Hoeveel vierkante meter is de tuin?",
      "options": ["38 m²", "19 m²", "84 m²", "144 m²"],
      "correctAnswer": 2,
      "stimulusAids": [{ "type": "geo", "data": { "width": 12, "height": 7, "showGrid": false, "unit": "m" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Oppervlakte rechthoek", "content": "Oppervlakte = lengte × breedte = 12 × 7 = 84 m². De eenheid is m² omdat je meters × meters doet.", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle_garden",
      "variantIndex": 2,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Oppervlakte met omtrek verward", "optionIndex": 0 },
          { "id": "met.opp-optellen-ipv-vermenigvuldigen", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 1 },
          { "id": "met.opp-verkeerde-afmeting", "label": "Zelfde zijde twee keer gebruikt", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De tuinarchitect berekent: oppervlakte = lengte × breedte = 12 × 7 = 84 m². Omdat je meters × meters doet, is de eenheid m² (vierkante meter).",
        "solutionSteps": ["Formule: oppervlakte = lengte × breedte", "Invullen: 12 × 7", "Uitkomst: 84 m²"],
        "distractorExplanations": {
          "0": "Je rekende waarschijnlijk de omtrek uit (12 + 7 + 12 + 7 = 38 m). Maar de vraag is naar oppervlakte: 12 × 7 = 84 m².",
          "1": "Je telde alleen 12 + 7 = 19 op. Voor oppervlakte vermenigvuldig je: 12 × 7 = 84 m².",
          "2": "Goed! 12 × 7 = 84 m².",
          "3": "Je deed waarschijnlijk 12 × 12 = 144. Maar gebruik de breedte (7), niet de lengte twee keer. Oppervlakte = lengte × breedte = 12 × 7 = 84 m²."
        }
      }
    },
    {
      "id": "MET-OPP-RECHT-003",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een timmerman maakt een plank. De oppervlakte is 36 cm² en de lengte is 9 cm. Wat is de breedte?",
      "options": ["3 cm", "4 cm", "6 cm", "18 cm"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Breedte berekenen", "content": "Oppervlakte = lengte × breedte. Dus: breedte = oppervlakte ÷ lengte = 36 ÷ 9 = 4 cm.", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle_reverse",
      "variantIndex": 3,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Oppervlakte met omtrek verward", "optionIndex": 0 },
          { "id": "met.opp-optellen-ipv-vermenigvuldigen", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 2 },
          { "id": "met.opp-delen-door-2-ipv-wortel", "label": "Door 2 gedeeld i.p.v. door de lengte", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Draai de formule om: breedte = oppervlakte ÷ lengte = 36 ÷ 9 = 4 cm. Controle: 9 × 4 = 36 cm² ✓.",
        "solutionSteps": ["Formule omdraaien: breedte = oppervlakte ÷ lengte", "Invullen: 36 ÷ 9", "Uitkomst: 4 cm", "Controle: 9 × 4 = 36 cm² ✓"],
        "distractorExplanations": {
          "0": "Je deelde waarschijnlijk door 12 i.p.v. door de lengte (9). Breedte = 36 ÷ 9 = 4 cm.",
          "1": "Goed! 36 ÷ 9 = 4 cm. Controle: 9 × 4 = 36 cm² ✓.",
          "2": "Je dacht waarschijnlijk dat 6 × 9 = 36. Maar 6 × 9 = 54, niet 36. De breedte is 36 ÷ 9 = 4 cm. Tip: controleer altijd door terug te vermenigvuldigen.",
          "3": "Je hebt 36 ÷ 2 = 18 gedaan. Maar je moet delen door de lengte (9), niet door 2. Breedte = oppervlakte ÷ lengte = 36 ÷ 9 = 4 cm."
        }
      }
    },
    {
      "id": "MET-OPP-RECHT-004",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een sportveldbeheerder meet een voetbalveld: 100 meter lang en 65 meter breed. Wat is de oppervlakte?",
      "options": ["330 m²", "165 m²", "10.000 m²", "6.500 m²"],
      "correctAnswer": 3,
      "stimulusAids": [{ "type": "geo", "data": { "width": 100, "height": 65, "showGrid": false, "unit": "m" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Oppervlakte groot vlak", "content": "Oppervlakte = 100 × 65 = 6.500 m². Handig: 100 × 65 = 100 × 60 + 100 × 5 = 6.000 + 500 = 6.500.", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle_large",
      "variantIndex": 4,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Oppervlakte met omtrek verward", "optionIndex": 0 },
          { "id": "met.opp-optellen-ipv-vermenigvuldigen", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 1 },
          { "id": "met.opp-verkeerde-afmeting", "label": "Zelfde zijde twee keer gebruikt", "optionIndex": 2 }
        ]
      },
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Oppervlakte = 100 × 65 = 6.500 m². Handig rekenen: splits 65 in 60 + 5. Dan 100 × 60 = 6.000 en 100 × 5 = 500. Samen 6.500 m².",
        "solutionSteps": ["Formule: oppervlakte = lengte × breedte", "100 × 65 = ?", "Splits: 100 × 60 = 6.000 en 100 × 5 = 500", "Totaal: 6.000 + 500 = 6.500 m²"],
        "distractorExplanations": {
          "0": "Je rekende de omtrek uit (100 + 65 + 100 + 65 = 330 m). Voor oppervlakte vermenigvuldig je: 100 × 65 = 6.500 m².",
          "1": "Je telde 100 + 65 = 165 op. Voor oppervlakte vermenigvuldig je: 100 × 65 = 6.500 m².",
          "2": "Je deed waarschijnlijk 100 × 100 = 10.000. Maar gebruik de breedte (65), niet de lengte twee keer. 100 × 65 = 6.500 m².",
          "3": "Goed! 100 × 65 = 6.500 m²."
        }
      }
    },
    {
      "id": "MET-OPP-RECHT-005",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een schilder moet de grootste muur verven. Welke muur heeft de grootste oppervlakte?",
      "options": ["15 m lang en 6 m hoog", "20 m lang en 4 m hoog", "10 m lang en 8 m hoog", "25 m lang en 3 m hoog"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Oppervlaktes vergelijken", "content": "Bereken elke oppervlakte: 15×6=90, 20×4=80, 10×8=80, 25×3=75. De grootste is 90 m².", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle_compare",
      "variantIndex": 5,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Oppervlakte met omtrek verward", "optionIndex": 1 },
          { "id": "met.opp-rekenfout", "label": "Rekenfout in vergelijking", "optionIndex": 2 },
          { "id": "met.opp-omtrek-verward", "label": "Langste muur gekozen zonder berekening", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bereken elke muur: 15 × 6 = 90 m², 20 × 4 = 80 m², 10 × 8 = 80 m², 25 × 3 = 75 m². De grootste is 90 m². Lessen: een lange smalle rechthoek heeft niet altijd de grootste oppervlakte.",
        "solutionSteps": ["Bereken alle oppervlaktes:", "15 × 6 = 90 m²", "20 × 4 = 80 m²", "10 × 8 = 80 m²", "25 × 3 = 75 m²", "Grootste: 90 m²"],
        "distractorExplanations": {
          "0": "Goed! 15 × 6 = 90 m² is de grootste oppervlakte.",
          "1": "Je dacht waarschijnlijk dat de langste muur de grootste oppervlakte heeft. Maar 20 × 4 = 80 m², terwijl 15 × 6 = 90 m². Lengte alleen zegt niets — bereken altijd l × b.",
          "2": "10 × 8 = 80 m² is bijna de grootste, maar 15 × 6 = 90 m² is groter.",
          "3": "Je koos waarschijnlijk de langste muur (25 m). Maar 25 × 3 = 75 m² is juist de kleinste! Een lange smalle muur kan kleiner zijn dan een kortere bredere."
        }
      }
    }
  ]
}